/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutDefaultEnvironmentReleasePlanPathParams = NonNullable<
  operations['PutDefaultEnvironmentReleasePlan']['parameters']['path']
>;

export type PutDefaultEnvironmentReleasePlanRequestBody = OperationRequestBodyContent<
  operations['PutDefaultEnvironmentReleasePlan']
>;

export interface Input extends PutDefaultEnvironmentReleasePlanPathParams {
  apiVersion?: string;
  body: PutDefaultEnvironmentReleasePlanRequestBody;
  header: NonNullable<operations['PutDefaultEnvironmentReleasePlan']['parameters']['header']>;
}

export async function PutDefaultEnvironmentReleasePlan(
  { apiVersion, body, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/api/v2/projects/{projectKey}/environments/{environmentKey}/default-release-plan', {
    params: { path, header },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
